const initGuideTabs = () => {
  const tabs = document.querySelectorAll('.guide-tab');
  const categories = document.querySelectorAll('.guides-category');

  if (!tabs.length) return;

  tabs.forEach((tab) => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();
      const target = tab.dataset.category;

      tabs.forEach((t) => t.classList.remove('active'));
      tab.classList.add('active');

      if (target === 'all') {
        categories.forEach((c) => { c.style.display = ''; });
      } else {
        categories.forEach((c) => {
          c.style.display = c.id === target ? '' : 'none';
        });
      }

      const grid = document.querySelector('.bysh__guides-index__grid');
      if (grid) {
        window.scrollTo({ top: grid.offsetTop - 80, behavior: 'smooth' });
      }
    });
  });
};

const initGuideRequestModal = () => {
  const modal = document.querySelector('.guide-request-modal');
  const openBtn = document.querySelector('.guide-request-btn');

  if (!modal || !openBtn) return;

  const closeBtns = modal.querySelectorAll(
    '.guide-request-modal__close, .btn-cancel, .guide-request-modal__backdrop',
  );
  const form = document.getElementById('guide-request-form');

  const openModal = () => {
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  };

  openBtn.addEventListener('click', openModal);
  closeBtns.forEach((btn) => btn.addEventListener('click', closeModal));

  modal.addEventListener('click', (e) => {
    if (e.target === modal || e.target.classList.contains('guide-request-modal__backdrop')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.style.display === 'flex') closeModal();
  });

  if (!form) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const topicField = form.querySelector('#guide_request_topic');
    if (topicField.value.trim().length < 5) {
      alert('Please describe the topic in at least 5 characters.');
      return;
    }

    const submitBtn = form.querySelector('.btn-submit');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting...';

    const csrfToken = document.querySelector('meta[name="csrf-token"]');
    const formData = new FormData(form);

    fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRF-Token': csrfToken ? csrfToken.content : '',
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (response.status === 201) {
          form.reset();
          const body = modal.querySelector('.guide-request-modal__body');
          const footer = modal.querySelector('.guide-request-modal__footer');
          body.innerHTML =
            '<p class="guide-request-success">Thanks! Your guide request has been submitted. We review requests regularly and prioritize the most popular topics.</p>';
          const closeBtn = document.createElement('button');
          closeBtn.type = 'button';
          closeBtn.className = 'btn-submit';
          closeBtn.textContent = 'Close';
          closeBtn.addEventListener('click', closeModal);
          footer.innerHTML = '';
          footer.appendChild(closeBtn);
        } else if (response.status === 429) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Submit Request';
          alert(
            'You have submitted several requests recently. Please wait a bit before submitting another.',
          );
        } else {
          return response.json().then((data) => {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Submit Request';
            alert(
              data.errors
                ? data.errors.join('\n')
                : 'Could not submit. Please check your input and try again.',
            );
          });
        }
      })
      .catch(() => {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Submit Request';
        alert('Something went wrong. Please try again.');
      });
  });
};

const initGuidesIndex = () => {
  initGuideTabs();
  initGuideRequestModal();
};

export default initGuidesIndex;
